<template>
  <b-card border-variant="secondary" :img-src="image" img-alt="Image" img-top tag="article" @click="goCourse(id)"
    class="card-article card-course" style="border-radius: 15px; height: 100%; overflow: hidden">
    <!-- title -->
    <div class="card-title-clamp">{{ header }}</div>
    <b-card-text class="short-desc" v-html="content"></b-card-text>
  </b-card>
</template>

<script>
export default {
  props: ["header", "content", "image", "id"],
  methods: {
    async goCourse(id) {
      const path = `/courses`;
      await this.$router.push({ path: path, query: { id: id } });
    },
  },
};
</script>

<style scoped>

 
.card-title {
  font-size: 18px;
  font-weight: bold;
}

.card-img,
.card-img-top {
  height: 151px;
  object-fit: cover;
}

.card-title-clamp {
  min-height: 54px;
  font-size: 18px;
  font-weight: bold;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* จำกัด 2 บรรทัด */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 12px;
}

.short-desc {
  font-size: 14px;
  /* color: #555; */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  /* สำหรับ Safari / Chromium */
  -webkit-line-clamp: 3;

  /* สำหรับ browser ใหม่ ๆ (มาตรฐาน) */
  line-clamp: 3;
}

 
</style>
